<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        i.fa.fa-chevron-left(@click.prevent="prev()")
        span Member Information
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      ValidationObserver(ref="Validation" slim)
        .row
          .col-md-6
            //- ValidationProvider(name="CID" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="CID") CID:
                //- select.form-control#branch(name="branch")
                  option(value="") -- Select --
                input.form-control#CID(:class="{'border-danger': errors.length}" v-model="form.cid" type="text" name="CID" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="membership type" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="membership") Membership type:
                v-select(:class="{'border-danger': errors.length}" v-model="form.membership", :options="memberships" label="name", :reduce="option => option.id")
                  //- template(#option="{ type }")
                    span {{type.name}}
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="title" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="title") Title (Atty., Hon, Engr.) <i>(optional)</i>:
                input.form-control#title(:class="{'border-danger': errors.length}" v-model="form.title", type="text" name="title" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="first name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="firstname") First name:
                input.form-control#firstname(:class="{'border-danger': errors.length}" v-model="form.firstName", type="text" name="firstname" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="middle name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="middlename") Middle name:
                input.form-control#middlename(:class="{'border-danger': errors.length}" v-model="form.middleName", type="text" name="middlename" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="last name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="lastname") Last name:
                input.form-control#lastname(:class="{'border-danger': errors.length}" v-model="form.lastName", type="text" name="lastname" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="alias" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="alias") Alias <i>(optional)</i>:
                input.form-control#alias(:class="{'border-danger': errors.length}" v-model="form.alias", type="text" name="lastname" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="date of birth" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="date_of_birth") Date of birth:
                //- input.form-control#date_of_birth(:class="{'border-danger': errors.length}" type="text" name="date_of_birth" placeholder="" v-model="form.dateOfBirth")
                date-picker.w-100(v-model="form.dateOfBirth" valueType="format", :input-class="['form-control', (errors.length > 0 ?'border-danger': '')]")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="country of birth" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="countryOfBirth") Country of birth:
                input.form-control#countryOfBirth(:class="{'border-danger': errors.length}" v-model="form.countryOfBirth", type="text" name="lastname" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="Resident" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="resident") Resident (Prk, Barangay, Mun,):
                //- input.form-control#resident(:class="{'border-danger': errors.length}" v-model="form.resident", type="text" name="lastname" placeholder="")
                textarea.form-control#resident(:class="{'border-danger': errors.length}" v-model="form.resident" name="resident")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="educational attainment" rules="required" v-slot="{errors}" slim :customMessages="{'required': 'The educational attainment is required.'}")
              .form-group
                label(for="educationalAttainment") Educational attainment:
                select.form-control#educationalAttainment(:class="{'border-danger': errors.length}" name="educationalAttainment" v-model="form.educationalAttainment")
                  option(value="") -- Select --
                  option(value="SCHOOL_LESS_1_YEAR") No schooling completed, or less than 1 year
                  option(value="ELEMENTARY_GRADUATE") Elementary graduate
                  option(value="HIGH_SCHOOL_GRADUATE") High school graduate
                  option(value="COLLEGE_UNDERGRADUATE") College undergraduate
                  option(value="BACHELOR_DEGREE") Bachelor Degree
                  option(value="MATERS_DEGREE") Maters Degree
                  option(value="PROFESSIONAL") Professional/Doctorate Degree
                small.text-danger(v-if="errors.length") {{ errors[0] }}
            //- ValidationProvider(name="educational attainment" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="educationalAttainment") Educational Attainment:
                input.form-control#educationalAttainment(:class="{'border-danger': errors.length}" v-model="form.educationalAttainment", type="text" name="educationalAttainment" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="employer" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="employer") Employer <i>(optional)</i>:
                input.form-control#employer(:class="{'border-danger': errors.length}" v-model="form.employer", type="text" name="employer" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
          .col-md-6
            ValidationProvider(name="date of membership" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="dateOfMembership") Date of membership:
                date-picker.w-100(:disabled="true" v-model="form.dateOfMembership" valueType="format", :input-class="['form-control', (errors.length > 0 ?'border-danger': '')]")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            //- ValidationProvider(name="last update" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="lastUpdate") Last update:
                date-picker.w-100(v-model="form.lastUpdate" valueType="format", :input-class="['form-control', (errors.length > 0 ?'border-danger': '')]")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="previous last name" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="previousLastName") Previous Last Name <i>(optional)</i>:
                input.form-control#previousLastName(:class="{'border-danger': errors.length}" v-model="form.previousLastName", type="text" name="previousLastName" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="suffix" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="suffix") Suffix <i>(optional)</i>:
                input.form-control#suffix(:class="{'border-danger': errors.length}" v-model="form.suffix", type="text" name="suffix" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="religion" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="religion") Religion:
                input.form-control#religion(:class="{'border-danger': errors.length}" v-model="form.religion", type="text" name="religion" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="nationality" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="nationality") Nationality:
                input.form-control#nationality(:class="{'border-danger': errors.length}" v-model="form.nationality", type="text" name="nationality" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="place of birth" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="placeOfBirth") Place of birth:
                textarea.form-control#placeOfBirth(:class="{'border-danger': errors.length}" v-model="form.placeOfBirth" name="placeOfBirth")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="gender" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="gender") Gender:
                select.form-control#civil_status(:class="{'border-danger': errors.length}" name="gender" v-model="form.gender")
                  option(value="") -- Select --
                  option(value="FEMALE") Female
                  option(value="MALE") Male
                  option(value="OTHER") Other
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="civil status" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="civilStatus") Civil Status:
                select.form-control#civilStatus(:class="{'border-danger': errors.length}" name="civilStatus" v-model="form.civilStatus")
                  option(value="") -- Select --
                  option(value="SINGLE") Single
                  option(value="MARRIED") Married
                  option(value="WIDOWED/WINDOWER") Windowed/Widowed/Windower
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            //- ValidationProvider(name="civil status" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="civilStatus") Civil Status:
                input.form-control#civilStatus(:class="{'border-danger': errors.length}" v-model="form.civilStatus", type="text" name="civilStatus" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="beneficiary", rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="beneficiary") Beneficiary:
                span.d-block
                  .form-check.form-check-inline
                    input.form-check-input#beneficiary4PS(type="checkbox" value="4PS" v-model="form.beneficiary")
                    label.form-check-label(for="beneficiary4PS", :class="{'text-danger': errors.length > 0}") 4P's
                  .form-check.form-check-inline
                    input.form-check-input#beneficiaryARB(type="checkbox" value="ARB" v-model="form.beneficiary")
                    label.form-check-label(for="beneficiaryARB", :class="{'text-danger': errors.length > 0}") ARB
                  .form-check.form-check-inline
                    input.form-check-input#beneficiaryARB(type="checkbox" value="IP" v-model="form.beneficiary")
                    label.form-check-label(for="beneficiaryARB", :class="{'text-danger': errors.length > 0}") IP
                  .form-check.form-check-inline
                    input.form-check-input#beneficiaryARB(type="checkbox" value="NA" v-model="form.beneficiary")
                    label.form-check-label(for="beneficiaryARB", :class="{'text-danger': errors.length > 0}") NA
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="employment" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="employment") Employment <i>(optional)</i>:
                input.form-control#employment(:class="{'border-danger': errors.length}" v-model="form.employment", type="text" name="employment" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="employer address" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="employerAddress") Employer Address <i>(optional)</i>:
                textarea.form-control#employerAddress(:class="{'border-danger': errors.length}" v-model="form.employerAddress" name="employerAddress")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
</template>

<style scoped="">
.v-select.border-danger >>> .vs__dropdown-toggle {
  border-color: var(--danger);
}
</style>

<script>
import { defineComponent, ref, reactive, watch } from '@vue/composition-api';

export default defineComponent({
  name: 'MemberInfo',
  props: {
    coops: {
      type: Array,
      required: true,
    },
    memberships: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  emits: ['prev', 'next'],

  setup(props, { emit }) {
    const Validation = ref(null);
    const sameAsPermanentAdd = ref(false);
    const form = reactive(props.value);
    const prev = () => {
      emit('prev');
    };
    const next = () => {
      emit('next');
    };
    const validate = () => {
      emit('input', form);
      return Validation.value.validate().then((success) => {
        if (success) {
          return Promise.resolve(success);
        }
        return Promise.reject(success);
      });
    };
    watch(sameAsPermanentAdd, (isSame) => {
      // console.log(isSame, previews)
      if (isSame) {
        form.presentAddress = form.permanentAddress;
      } else {
        form.presentAddress = '';
      }
    });
    return {
      sameAsPermanentAdd,
      Validation,
      validate,
      form,
      prev,
      next,
    };
  },
});
</script>
